import logo200Image from '../assets/img/logo/logo_2.png'
import React from 'react'
import { Button, Form, FormGroup, Input, Label, Row, Col, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Typography from '../components/Typography'
import axios from 'axios'
import { MdCameraAlt, MdFace, MdDone, MdClear, MdLabel } from 'react-icons/md'
import Avatar from '../components/Avatar'
import userPlaceholder from '../assets/img/users/profile.jpg'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { getPayment, getPayment_v2 } from '../utils/dropdownlist'

class PosPaymentTypeForm extends React.Component {
  _isMounted = true
  constructor(props) {
    super(props)
    this.state = {
      isEdit: false,
      isGlobal: true,
      company_id: '',
      payment_id: '',
      payment_code: '',
      name: '',
      default_full: '',
      default_value: '0',
      ticket: '',
      image: '',
      options: '',
      imagePreviewUrl: '',
      paymentList: [],
      mode: '',
    }
  }

  componentDidMount() {
    //getPayment.call(this);
    this.getPaymentList()
    //this.getPayment();
    if (this.props.data.isGlobal) {
      if (this.props.data.isEdit) {
        let id = this.props.data.selectedId
        const data = this.props.data.paymentTypeList.find(e => e.id === id)
        this.setState({
          id: id,
          payment_code: data.payment_code,
          name: data.name,
          default_full: data.default_full,
          default_value: data.default_value,
          ticket: data.ticket,
          image: data.image,
          mode: data.mode,
          options: data.options,
          isEdit: true,
          isGlobal: this.props.data.isGlobal,
        })
      }
    } else {
      this.setState({
        store_id: this.props.data.store_id,
        isGlobal: this.props.data.isGlobal,
      })
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  getPaymentList = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
    }

    axios
      .post(url + ':3001/v1/payment', data)
      .then(response => {
        const result = response.data
        const storePayment = this.props.data.paymentTypeList

        let PaymentOp = result.data.filter(x => !storePayment.some(y => y.id === x.id))

        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({ paymentList: PaymentOp })
        }
      })
      .catch(error => {
        console.log(error)
        alert(error)
      })
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  checkboxChangeHandler = event => {
    this.setState({
      [event.target.name]: !this.state[event.target.name],
    })
  }

  handleImageChange = event => {
    let reader = new FileReader()
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0]
      console.log(event.target.files)

      reader.onloadend = () => {
        this.setState({
          imagePreviewUrl: reader.result,
        })
      }

      reader.readAsDataURL(file)
    }
  }

  handleSubmit = event => {
    event.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    let image = ''
    if (this.state.imagePreviewUrl) {
      image = this.state.imagePreviewUrl.split(',')[1]
    }
    if (this.state.isGlobal) {
      if (!this.state.isEdit) {
        this.createPayment(user, comp, url, image)
      } else {
        this.editPayment(user, comp, url, image)
      }
    } else {
      this.addStorePayment(user, url)
    }
  }

  createPayment(user, comp, url, image) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      payment_code: this.state.payment_code,
      name: this.state.name,
      store_location: this.state.store_location,
      default_full: this.state.default_full ? '1' : '0',
      default_value: this.state.default_value,
      ticket: this.state.ticket ? '1' : '0',
      b64image: image,
      options: this.state.options,
      mode: this.state.mode,
      created_by: user.email,
    }

    axios
      .post(url + ':3001/v2/payment/create', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'New payment added successfully.', 'success', false)
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message)
        } else {
          alert('Error', error.message)
        }
      })
  }

  editPayment(user, comp, url, image) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      id: this.state.id,
      company_id: comp.CompanyID,
      payment_code: this.state.payment_code,
      name: this.state.name,
      store_location: this.state.store_location,
      default_full: this.state.default_full ? '1' : '0',
      default_value: this.state.default_value,
      ticket: this.state.ticket ? '1' : '0',
      b64image: image,
      options: this.state.options,
      mode: this.state.mode,
      update_by: user.email,
    }

    axios
      .post(url + ':3001/v2/payment/update', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(
          <MdDone />,
          'Payment details updated successfully.',
          'success', //'error' post when return error
          false,
        )
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message)
        }
        // else if (error.request) {
        //   console.log(error.request);
        // }
        else {
          alert('Error', error.message)
        }
      })
  }

  addStorePayment(user, url) {
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      payment_id: this.state.payment_id,
      store_id: this.state.store_id,
      added_by: user.email,
    }

    axios
      .post(url + ':3001/v1/store/payment/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true) {
          this.props.closeModal(<MdClear />, result.message, 'error', false)
          return
        }

        this.props.closeModal(<MdDone />, 'Payment added successfully.', 'success', false)
      })
      .catch(error => {
        if (error.response) {
          alert(error.response.data.message)
        } else {
          alert('Error', error.message)
        }
      })
  }

  render() {
    return (
      <Form className="AuthForm" onSubmit={this.handleSubmit}>
        <ModalHeader toggle={this.props.onToggleModal()}>Payment {this.state.isGlobal ? 'Details' : 'List'}</ModalHeader>
        <ModalBody>
          {this.state.isGlobal ? (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label for="payment_code">Payment Code</Label>
                  <Input type="text" name="payment_code" value={this.state.payment_code} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup>
                  <Label for="name">Name</Label>
                  <Input type="text" name="name" value={this.state.name} onChange={this.changeHandler} required />
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox" name="default_full" checked={this.state.default_full} onChange={this.checkboxChangeHandler} /> Default Full
                  </Label>
                </FormGroup>
                <br />
                <FormGroup>
                  <Label for="default_value">Default Value</Label>
                  <Input type="text" name="default_value" value={this.state.default_value} onChange={this.changeHandler} />
                </FormGroup>
                <FormGroup check>
                  <Label check>
                    <Input type="checkbox" name="ticket" checked={this.state.ticket} onChange={this.checkboxChangeHandler} /> Ticket
                  </Label>
                </FormGroup>
                <br />
                <FormGroup>
                  <Label>Mode</Label>
                  <Input type="select" name="mode" value={this.state.mode} onChange={this.changeHandler} required>
                    <option></option>
                    <option value="MANUAL">MANUAL</option>
                    <option value="PAYNOWQR">PAYNOWQR</option>
                    <option value="PAYNOWQFPAY">PAYNOWQFPAY</option>
                    <option value="PAYPAL">PAYPAL</option>
                    <option value="FIRSTDATA">FIRSTDATA</option>
                    <option value="HITPAY">HITPAY</option>
                  </Input>
                </FormGroup>
                <FormGroup>
                  <Label>Options</Label>
                  <Input type="text" name="options" value={this.state.options} onChange={this.changeHandler} />
                </FormGroup>
                <FormGroup>
                  <Label for="image">Image</Label>
                  <Input type="file" name="image" onChange={this.handleImageChange} />
                </FormGroup>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col md={12}>
                <FormGroup>
                  <Label></Label>
                  <Input type="select" name="payment_id" onChange={this.changeHandler} required>
                    <option></option>
                    {this.state.paymentList &&
                      this.state.paymentList.map(item => {
                        return (
                          <option key={item.id} value={item.id}>
                            {item.name}
                          </option>
                        )
                      })}
                  </Input>
                </FormGroup>
              </Col>
            </Row>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="theme-button theme-button-secondary" onClick={this.props.onToggleModal()}>
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            Save
          </Button>
        </ModalFooter>
      </Form>
    )
  }
}

export const STATE_ADD = 'ADD'
export const STATE_EDIT = 'EDIT'
export default PosPaymentTypeForm
